// CustomersContext.js
import { createContext, useState, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';

const CustomersContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [spin, setSpin] = useState(false);
  const [lists, setLists] = useState({
    vendors: [],
    pros: [],
    oob: [],
  });
  const [error, setError] = useState(null);

  const fetchVendorList = useCallback(async (forceRefresh = false) => {
    // Skip cache if forceRefresh is true
    if (!forceRefresh) {
      const cachedData = localStorage.getItem('customerData');
      const timestamp = localStorage.getItem('customerDataTimestamp');
      const cacheAge = Date.now() - (timestamp ? parseInt(timestamp) : 0);
      if (cachedData && cacheAge < 5 * 60 * 1000) { // 5-minute cache expiry
       
        const parsedData = JSON.parse(cachedData);
        setLists(parsedData);
        setSpin(false);
        return;
      }
    }
   
    setSpin(true);
    try {
      const res = await axios.get('https://highgroundapi.herokuapp.com/customers/all');
       // const res = await axios.get('http://localhost:5001/customers/all',{id:1});
 
      const vendors = [];
      const pros = [];
      const oob = [];
      res.data.forEach((item) => {
        if (item.pros === '1') vendors.push(item);
        else if (item.pros === '0') pros.push(item);
        else if (item.pros === '2') oob.push(item);
      });

      const newLists = { vendors, pros, oob };
      setLists(newLists);
      localStorage.setItem('customerData', JSON.stringify(newLists));
      localStorage.setItem('customerDataTimestamp', Date.now());
      setError(null);
    } catch (err) {
      console.error('Error fetching customer data:', err);
      setError('Failed to fetch customer data. Please try again later.');
    } finally {
      setSpin(false);
    }
  }, []);



  const contextValue = useMemo(
    () => ({
      spin,
      setSpin,
      lists,
      setLists,
      error,
      refreshData: (forceRefresh = false) => fetchVendorList(forceRefresh),
    }),
    [spin, lists, error, fetchVendorList]
  );

  if (process.env.NODE_ENV === 'development') {
    
  }

  return (
    <CustomersContext.Provider value={contextValue}>
      {children}
    </CustomersContext.Provider>
  );
};

export default CustomersContext;